import { div, h2, input, label, span, textarea } from '@srfnstack/fntags'
import { CreditButton } from '../../components/CreditButton.js'
import { NumberSpinner } from '../../components/NumberSpinner.js'
import { ModelSelector, ALL_IMAGE_PROVIDERS } from '../../components/ModelSelector.js'

const styleCard = (value, icon, title, desc, manualBackground) =>
  div({
    class: manualBackground.bindAttr(v =>
      `flex-1 cursor-pointer border-2 rounded-xl p-3 transition-colors select-none ${v === value ? 'border-primary bg-primary/10' : 'border-base-300 hover:border-base-content/30'}`
    ),
    onclick: () => manualBackground(value)
  },
  div({ class: 'font-bold text-sm' }, `${icon} ${title}`),
  div({ class: 'text-xs opacity-60 mt-0.5' }, desc)
  )

export const ManualPrompt = ({ manualPrompt, manualBatchSize, manualBackground, manualImage, manualImageInstructions, manualMultipliers, ingestStatus, handleManualGenerate, handleLuckyGenerate, imageModel }) =>
  div({ class: 'card bg-base-200 shadow-xl border border-base-300' },
    div({ class: 'card-body p-6 space-y-5' },
      div({},
        h2({ class: 'card-title' }, 'Manual Prompt Creation'),
        span({ class: 'text-xs opacity-50' }, 'Describe your creative vision or let the AI surprise you.')
      ),

      div({ class: 'flex flex-col gap-2' },
        span({ class: 'text-xs font-bold uppercase opacity-50' }, 'Artwork Style'),
        div({ class: 'flex gap-3' },
          styleCard('AUTO', '🖼️', 'Surface Art', 'Canvas, posters — full scene artwork', manualBackground),
          styleCard('ISOLATED_BLACK', '✂️', 'Isolated Art', 'T-shirts, apparel — transparent background', manualBackground)
        )
      ),

      textarea({
        class: 'textarea textarea-bordered h-28 leading-relaxed',
        placeholder: 'Describe your creative vision...',
        value: manualPrompt.bindAttr(),
        oninput: (e) => manualPrompt(e.target.value)
      }),

      div({ class: 'grid grid-cols-1 sm:grid-cols-3 gap-4' },
        div({ class: 'form-control' },
          label({ class: 'label' }, span({ class: 'label-text font-bold text-xs uppercase opacity-50' }, 'Reference Image (Optional)')),
          input({
            type: 'file',
            class: 'file-input file-input-bordered file-input-sm w-full',
            accept: 'image/*',
            onchange: (e) => manualImage(e.target.files[0])
          }),
          manualImage.bindAs(img => img
            ? textarea({
              class: 'textarea textarea-bordered textarea-sm h-16 mt-2',
              placeholder: 'How should we use this image? e.g. "put this person in a spaceship", "make this cat the Hulk", "use this as style reference"',
              value: manualImageInstructions.bindAttr(),
              oninput: (e) => manualImageInstructions(e.target.value)
            })
            : ''
          )
        ),
        div({ class: 'form-control' },
          label({ class: 'label' }, span({ class: 'label-text font-bold text-xs uppercase opacity-50' }, 'No. images to generate')),
          NumberSpinner({ state: manualBatchSize, min: 1, max: 100 })
        ),
        ModelSelector({ model: imageModel, providers: ALL_IMAGE_PROVIDERS })
      ),

      div({ class: 'flex items-center justify-between gap-4' },
        CreditButton({
          actionCode: 'PROMPT_ENHANCE',
          label: span({ class: 'flex items-center gap-2' },
            span({ class: 'material-symbols-rounded !text-base' }, 'casino'),
            "I'm Feeling Lucky"
          ),
          class: 'btn btn-secondary btn-sm',
          onclick: handleLuckyGenerate,
          disabled: ingestStatus.bindAttr(s => s && s.loading),
          multipliers: manualMultipliers
        }),
        CreditButton({
          actionCode: 'PROMPT_ENHANCE',
          label: 'Start Generation',
          class: 'btn btn-primary btn-sm px-8',
          onclick: handleManualGenerate,
          disabled: ingestStatus.bindAttr(s => s && s.loading),
          multipliers: manualMultipliers
        })
      )
    )
  )
